import { Skeleton } from "antd";

export const PageLoader = () => {
  return (
    <>
      <Skeleton active />
      <Skeleton active />
    </>
  );
};
